import { render } from "./CoachesList.vue?vue&type=template&id=1da705ec&scoped=true"
import script from "./CoachesList.vue?vue&type=script&lang=js"
export * from "./CoachesList.vue?vue&type=script&lang=js"

import "./CoachesList.vue?vue&type=style&index=0&id=1da705ec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1da705ec"

export default script